var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGrey2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 10L19.8782 14.1218L24 15.6471L19.8782 17.1723L18.3529 21.2941L16.8277 17.1723L12.7059 15.6471L16.8277 14.1218L18.3529 10Z",
    stroke: "#2D2B32",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2941 19.4118L12.6265 21.3735L14.5882 22.7059L12.6265 24.0382L11.2941 26L9.96176 24.0382L8 22.7059L9.96176 21.3735L11.2941 19.4118Z",
    stroke: "#2D2B32",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGrey2Icon);
export default __webpack_public_path__ + "static/media/star-grey2-icon.46827082c3f0578e301d926e71076597.svg";
export { ForwardRef as ReactComponent };